import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetBolt: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M13 2L4 14h8l-1 8 9-12h-8z" />
      </svg>
    </div>
  );
};

export default WidgetBolt;
